// extracted by mini-css-extract-plugin
export default {"gameList":"GameList_gameList__ZmdWg","column":"GameList_column__iko+x"};